import React from 'react';

// Carte de section (Composants-2, Paramètres 2026-09-09) : entête titre 600
// 16px + sous-titre 12px gris + action à droite, corps 24px (ou `flush` pour
// un tableau bord à bord), pied filet gray-100 aligné à droite.
// Même cadre pour TOUS les onglets de Paramètres (owner : « comme Tarification »).
const SectionCard = ({ title, sub, action, footer, flush = false, children, className = '' }) => (
  // Colonne flex : quand la carte est étirée (Paramètres, hauteur « Nouvelle
  // vente »), le corps prend la place et le pied reste collé en bas. Sans
  // étirement, rendu identique au bloc d'avant.
  <section className={`bg-white rounded-2xl border border-gray-200 flex flex-col ${flush ? 'overflow-hidden' : ''} ${className}`}>
    {(title || action) && (
      <header className="flex items-start justify-between gap-3 px-6 py-4 border-b border-gray-100">
        <div className="min-w-0">
          {title && <h2 className="text-base font-semibold text-gray-900">{title}</h2>}
          {sub && <p className="text-xs text-gray-400 mt-0.5 tabular-nums">{sub}</p>}
        </div>
        {action}
      </header>
    )}
    <div className={`sc-body flex-1 ${flush ? '' : 'p-6'}`}>{children}</div>
    {footer && (
      <footer className="flex items-center justify-end gap-2 px-6 py-4 border-t border-gray-100">{footer}</footer>
    )}
  </section>
);

export default SectionCard;
